// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__E08Kt","sendOtp":"AuthorizeToLogin_sendOtp__yhQME"};